import { createSlice } from "@reduxjs/toolkit";

export const favoritesSlice = createSlice({
    name: "favorites",
    initialState: [],
    reducers: {
        addFavorite: (state, action) => [...state, action.payload],
        removeFavorite: (state, action) => state.filter((val) => val.id !== action.payload),
        clearFavorites: () => [],
    },
});

export const { addFavorite, removeFavorite, clearFavorites } = favoritesSlice.actions;

export const favoritesReducer = favoritesSlice.reducer;
